import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PanelOptionsService {
  numberOfPartsOption;
  commitmentAmount;
  price;
  paymentMethods: any;
  selectedPaymentMethodId;
  selectedNumberOfParts;

  constructor() {
    this.numberOfPartsOption = [];
    this.commitmentAmount = 0;
    this.paymentMethods = [];
  }

  setPreOrderOptions(options) {
    const { pricePerPart, partsMaxInvestment, partsMinInvestment } = options;
    for (let i = partsMinInvestment; i <= partsMaxInvestment; i++) {
      this.numberOfPartsOption.push(i);
    }
    this.price = pricePerPart;
  }

  getNumberOfPartsOption() {
    return this.numberOfPartsOption;
  }

  getPricePerPart() {
    return this.price;
  }

  setPaymentMethods(methods) {
    this.paymentMethods = methods;
    this.selectedPaymentMethodId = this.paymentMethods[0].paymentMethodId;
  }

  getPaymentMethods() {
    return this.paymentMethods.map(option => option.paymentMethodName) || [];
  }

  getDefaultMethod() {
    return (
      this.paymentMethods.length > 0 && this.paymentMethods[0].paymentMethodName
    );
  }

  getSelectedMethodId() {
    return this.selectedPaymentMethodId;
  }

  setSelectedMethod(name) {
    this.paymentMethods.map(option => {
      if (option.paymentMethodName === name) {
        this.selectedPaymentMethodId = option.paymentMethodId;
      }
    });
  }

  setCommitmentAmount(amount) {
    this.commitmentAmount = amount;
  }

  getCommitmentAmount() {
    return this.commitmentAmount;
  }

  setSelectedNumberOfParts(number) {
    this.selectedNumberOfParts = number;
  }

  getSelectedNumberOfParts() {
    return this.selectedNumberOfParts;
  }
}
